import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { getInboxSettings, upsertInboxSettings } from '../../store/actions/tenantAction';
import { useDispatch, useSelector } from 'react-redux';
import AudioRecorder from '../../components/AudioRecorder';

function InboxSetting({ showSidebar }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [inboxSettings, setInboxSettings] = useState({});
    const globalReducer = useSelector((state) => state.globalReducer);
    const [audioData, setAudioData] = useState(null);

    useEffect(() => {
        dispatch(getInboxSettings({
            criteria: { tenantWabaId: globalReducer?.waba?.id }
        }, a => {
            if (a?.data?.length > 0) {
                setInboxSettings(a?.data[0]);
            }
        }));
    }, []);

    const onSaveSubmit = (e) => {
        e.preventDefault();
        dispatch(upsertInboxSettings({ ...inboxSettings, tenantWabaId: globalReducer?.waba?.id }, (a) => {
            dispatch({ type: 'SHOW_SNACKBAR', payload: { type: "success", message: "Settings saved successfully", open: true } });
        }));
    }

    return (
        <div className="h-screen">
            <div className={`fixed top-[30px] ${showSidebar ? "fullWidth" : "fullWidth1"} transition-all duration-200 ease-out z-30 bg-white mb-[0px]`}>
                <div className="flex gap-5 justify-between px-5 py-[8.5px] min-h-[53.8px] text-base text-center bg-white border-b-[1px] border-[#e9ebf0] border-solid max-md:flex-wrap">
                    <div className="flex gap-2 items-center my-auto font-medium text-black whitespace-nowrap cursor-pointer">
                        <i className="fa-solid fa-gear text-[14px] text-theme"></i>
                        <div className="text-[14px] font-medium">
                            {t("Inbox Setting")}
                        </div>
                    </div>
                </div>
            </div>
            <div className='overflow-x-auto h-full'>
                <form className='bg-gray-100 text-black font-medium px-5 pt-[6px] mt-[5rem] box-border border-b' onSubmit={onSaveSubmit}>
                    <div className='border p-4 mt-3 bg-white rounded-md'>
                        <div className='flex items-center gap-2'>
                            <i class="fa-solid fa-bell text-[18px] text-theme"></i>
                            <div className='text-[16px] font-medium'>
                                {t("Notification Settings")}
                            </div>
                            <div>
                                <span className='text-[12px] text-gray-500'>
                                    {t("You can customize your notification settings for different events.")}
                                </span>
                            </div>
                        </div>
                        <div className='mt-4 pl-6 bg-gray-100 rounded-md py-2 pr-6'>
                            <div className='flex justify-between gap-2 pb-2'>
                                <div className='text-[14px] font-medium'>
                                    {t("Incoming Tickets Sound")}
                                    <p className='text-[11px] text-gray-500'>
                                        {t("This notification will notify when you will have a new ticket in inbox")}
                                    </p>
                                </div>
                                <div className='mt-2'>
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={inboxSettings?.notificationSound?.incomingTicketsSound} onChange={(e) => {
                                            setInboxSettings({ ...inboxSettings, notificationSound: { ...inboxSettings.notificationSound, incomingTicketsSound: e.target.checked } });
                                        }} className="sr-only peer" />
                                        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-theme"></div>
                                    </label>
                                </div>
                            </div>
                            <div className='flex justify-between gap-2 mt-2 pb-2'>
                                <div className='text-[14px] font-medium'>
                                    {t("Incoming Message Sound")}
                                    <p className='text-[11px] text-gray-500'>
                                        {t("Incoming Message Sound allows you to get sound when you are away")}
                                    </p>
                                </div>
                                <div className='mt-2 items-end'>
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={inboxSettings?.notificationSound?.incomingMessageSound} onChange={(e) => {
                                            setInboxSettings({ ...inboxSettings, notificationSound: { ...inboxSettings.notificationSound, incomingMessageSound: e.target.checked } });
                                        }} className="sr-only peer" />
                                        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-theme"></div>
                                    </label>
                                </div>
                            </div>
                            <div className='flex justify-between gap-2 mt-2'>
                                <div className='text-[14px] font-medium'>
                                    {t("Browser Notification")}
                                    <p className='text-[11px] text-gray-500'>
                                        {t("Browser Notification allows you to send notification in Inbox")}
                                    </p>
                                </div>
                                <div className='mt-2 items-end'>
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" checked={inboxSettings?.notificationSound?.browserNotification} onChange={(e) => {
                                            setInboxSettings({ ...inboxSettings, notificationSound: { ...inboxSettings.notificationSound, browserNotification: e.target.checked } });
                                        }} className="sr-only peer" />
                                        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-theme"></div>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='border p-4 mt-3 bg-white rounded-md'>
                        <div className='flex items-center gap-2'>
                            <i className="fa-solid fa-message text-[14px] text-theme"></i>
                            <div className='text-[16px] font-medium'>
                                {t("Inbox Preferences")}
                            </div>
                        </div>
                        <div>
                            <span className='text-[12px] text-gray-500'>
                                {t("Personalize your inbox for optimal organization and efficiency.")}
                            </span>
                        </div>
                        <div className='mt-4 pl-6 bg-gray-100 rounded-md py-2 pr-6'>
                            <div className='flex justify-between gap-2 pb-2'>
                                <div className='flex items-center gap-2'>
                                    <div className='text-[14px] font-medium'>
                                        {t("Conversation Preferences")}
                                        <div className="pt-0">
                                            <div className="flex gap-4">
                                                <label htmlFor="oneSided" className={`bg-card text-card-foreground relative w-[273px] h-[200px] border shadow-none p-1 rounded-[8px] ${inboxSettings?.conversationPreferences === "onesided" ? "border-primary" : "border-gray-300"}`}>
                                                    <img className='p-3' src="/images/oneSidedView.svg" alt="onSidedViewIcon" />
                                                    <input checked={inboxSettings?.conversationPreferences === "onesided"} onChange={(e) => {
                                                        setInboxSettings({ ...inboxSettings, conversationPreferences: "onesided" });
                                                    }}
                                                        type="radio" id="oneSided"
                                                        name="conversation_preferences"
                                                        className="absolute border-gray-300 focus:ring-primary text-primary top-7 right-7"
                                                    />
                                                    <h3 className="tracking-tight mt-1 rtl:text-right text-sm font-medium text-gray-800 px-1">
                                                        One Sided View{" "}
                                                    </h3>
                                                    <p className="text-xs font-normal text-gray-600 px-1">
                                                        All messages are displayed in a single list.
                                                    </p>
                                                </label>
                                                <label htmlFor="zigzag" className={`bg-card text-card-foreground relative w-[273px] h-[200px] border shadow-none p-1 rounded-[8px] ${inboxSettings?.conversationPreferences === "zigzag" ? "border-primary" : "border-gray-300"}`}>
                                                    <img className='p-3' src="/images/zigZagView.svg" alt="zigZagView" />
                                                    <input checked={inboxSettings?.conversationPreferences === "zigzag"} onChange={(e) => {
                                                        setInboxSettings({ ...inboxSettings, conversationPreferences: "zigzag" });
                                                    }}
                                                        type="radio" id="zigzag"
                                                        name="conversation_preferences"
                                                        className="absolute border-gray-300 focus:ring-primary text-primary top-7 right-7"
                                                        defaultChecked=""
                                                    />
                                                    <h3 className="tracking-tight mt-1 rtl:text-right text-sm px-1 font-medium text-gray-800">
                                                        Zig-Zag View
                                                    </h3>
                                                    <p className="text-xs font-normal text-gray-600 px-1">
                                                        Messages are displayed in a zig-zag pattern.
                                                    </p>
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='border p-4 mt-3 bg-white rounded-md'>
                        <div className='flex items-center gap-2'>
                            <i className="fa-solid fa-circle-info text-[14px] text-theme"></i>
                            <div className='text-[16px] font-medium'>
                                {t("Saved Replies")}
                            </div>
                        </div>
                        <div>
                            <span className='text-[12px] text-gray-500'>
                                {t("Saved Replies let you store frequently used messages with a keyword, making customer interactions quicker and more consistent. Access them in the inbox by pressing # or clicking the saved replies icon.")}
                            </span>
                        </div>
                        <div className='mt-4 pl-6 bg-gray-100 rounded-md py-2 pr-6'>
                            <div className='flex justify-between gap-2 pb-2'>
                                <div className='flex items-center gap-2'>
                                    <i className="fa-solid fa-bell text-[14px] text-theme"></i>
                                    <div className='text-[14px] font-medium'>
                                        {t("Incoming Tickets Sound")}
                                        <p className='text-[11px] text-gray-500'>
                                            {t("This notification will notify when you will have a new ticket in inbox")}
                                        </p>
                                    </div>
                                </div>
                                <div className='mt-2'>
                                    <label className="inline-flex items-center cursor-pointer">
                                        <input type="checkbox" onChange={(e) => {

                                        }} className="sr-only peer" />
                                        <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-theme"></div>
                                    </label>
                                </div>
                            </div>
                            <AudioRecorder
                                onStop={(data) => {
                                    setAudioData(data);
                                }}
                            />
                        </div>
                        <button type='button' className="min-w-[100px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary" onClick={() => {
                            if (audioData) {

                                const formData = new FormData();
                                const audioFile = new File(
                                    [audioData.audioBlob],
                                    `recording${new Date().getTime()}.mp3`,
                                    { type: "audio/mp3" }
                                );
                                formData.append("file", audioFile);
                                const url = URL.createObjectURL(audioFile);
                                const a = document.createElement("a");
                                a.href = url;
                                a.download = audioFile.name;
                                document.body.appendChild(a);
                                a.click();
                                document.body.removeChild(a);
                                URL.revokeObjectURL(url);
                                // dispatch(
                                //     speechPrescription(
                                //         formData,
                                //         (a) => {
                                //             dispatch({
                                //                 type: 'SHOW_SNACKBAR',
                                //                 payload: { type: "success", message: "Audio uploaded successfully", open: true }
                                //             });
                                //         }
                                //     )
                                // );
                            }
                        }}>
                            {t('upload')}
                        </button>
                    </div>
                    <div className="flex justify-end mt-3 bg-white py-2 px-4 rounded-md">
                        <button type='submit' className="min-w-[100px] text-center px-[16px] py-[6px] text-white font-medium text-[14px] bg-theme transition-all ease-in-out rounded cursor-pointer hover:bg-primary">
                            {t('Save')}
                        </button>
                    </div>
                    <div className='h-7'></div>
                </form>
            </div >
        </div >
    )
}

export default InboxSetting